import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment, endpoints } from '@environment';
import {
  Subscription,
  SubscriptionProduct,
  CheckoutSessionRequest,
  CheckoutSessionResponse,
} from '@core/models';

@Injectable({ providedIn: 'root' })
export class SubscriptionService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/${endpoints.v1.subscriptions}`;

  getSubscription(): Observable<Subscription> {
    return this.http.get<Subscription>(this.baseUrl);
  }

  activateFree(): Observable<Subscription> {
    return this.http.post<Subscription>(`${this.baseUrl}/free`, {});
  }

  cancel(): Observable<Subscription> {
    return this.http.post<Subscription>(`${this.baseUrl}/cancel`, {});
  }

  getProducts(): Observable<SubscriptionProduct[]> {
    return this.http.get<SubscriptionProduct[]>(`${this.baseUrl}/get-products`);
  }

  createCheckoutSession(
    request: CheckoutSessionRequest
  ): Observable<CheckoutSessionResponse> {
    return this.http.post<CheckoutSessionResponse>(
      `${this.baseUrl}/create-checkout-session`,
      request
    );
  }
}
